// auth
export const SET_AUTH_USER = 'SET_AUTH_USER'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_CLAIMS = 'SET_USER_CLAIMS'

// events
export const SET_EVENTS = 'SET_EVENTS'
export const SET_EVENTS_LOADING = 'SET_EVENTS_LOADING'

// notifications
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_PROMPT = 'SET_PROMPT'

// language
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE'

// contact
export const SET_CONTACT_MODAL = 'SET_CONTACT_MODAL'
